import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from 'lucide-react';
import { useAuth } from '@/contexts/UnifiedAuthContext';
import { useProfile } from '@/hooks/useProfile';

export const LanguageSwitcher = () => {
    const { i18n, t } = useTranslation();
    const { user } = useAuth();
    const { profile, updateLang } = useProfile(user?.id);

    // Восстанавливаем язык из профиля при загрузке
    useEffect(() => {
        if (profile?.lang && profile.lang !== i18n.language?.split('-')[0]) {
            i18n.changeLanguage(profile.lang);
        }
    }, [profile?.lang]);

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        if (user) {
            updateLang(lng);
        }
    };

    const currentLanguage = i18n.language?.split('-')[0];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="w-9 h-9">
                    <Globe className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all" />
                    <span className="sr-only">{t('common.language', 'Language')}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" side="bottom" sideOffset={8}>
                <DropdownMenuItem onClick={() => changeLanguage('ru')} className={currentLanguage === 'ru' ? 'bg-accent' : ''}>
                    🇷🇺 Русский
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => changeLanguage('en')} className={currentLanguage === 'en' ? 'bg-accent' : ''}>
                    🇬🇧 English
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => changeLanguage('de')} className={currentLanguage === 'de' ? 'bg-accent' : ''}>
                    🇩🇪 Deutsch
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
